import React from 'react'
import _ from 'common-tools/LodashHelper'
import { FAIcon, RouteLink, FileImg } from 'common-controls/Core'
import Tooltip from 'rc-tooltip'
import { sh, ah, ReduxWrapper, compose, QueryWrapper } from 'common-data/datahelpers'
import { MessageBusWrapper } from 'common-tools/MessageBusHelper'
export class PrimaryMenuItem {
  constructor (text, icon, link) {
    this.text = text || ''
    this.icon = icon || 'plus'
    this.link = link || ''
  }
}

function LayoutPrimaryMenuPlain (props) {
  const { menu = [], SessionToken, logoLink, logoToolTip, SessionAccount = {}, shellPath = 'Me', SwitchAgency, clearUser } = props

  function renderMenus () {
    return _.map(menu, (m, i) => {
      return ([
        <RouteLink key={m.link} to={m.link} className='leftnavlink' activeClassName='leftnav-link-active'>
          <FAIcon name={m.icon} />
        </RouteLink>,
        <div key={`${m.link}_text`} className="leftnav-txt-link text-center">{m.text}</div>
      ])
    })
  }

  function renderProfile () {
    const p = {
      link: `/${shellPath}/Account/Documents`,
      icon: 'user',
      toolTip: `Hi ${SessionAccount.FirstName}`,
      toolTipPlacements: 'right',
      pictureKey: SessionAccount.ProfilePictureKey
    }

    let picture = p.pictureKey
      ? <FileImg className='nv-img' pictureKey={p.pictureKey} SessionToken={SessionToken} />
      : <FAIcon name={p.icon || 'user'} />

    if (p.toolTip) {
      return <Tooltip placement='right' overlay={p.toolTip}>
        <div className="navbtm">
          <RouteLink key={p.link} to={p.link}>
            {picture}
          </RouteLink>
        </div>
      </Tooltip>
    } else {
      return <div className="navbtm">
        <RouteLink key={p.link} to={p.link}>
          {picture}
        </RouteLink>
      </div>
    }
  }

  async function clearUserOut () {
    if (logoLink === '/Me/Dashboard') {
      await SwitchAgency({ UserKey: 'Exit' }).then(() => {
        clearUser()
      })
      clearUser()
    }
  }

  function renderLogo () {
    let logo = <RouteLink
      onClick ={async () => { await clearUserOut }}

      exact className='leftnavlink-home' to={logoLink || '/'}><img className='leftnavhome' src='/content/images/cs-logo-icon.png' />
    </RouteLink>

    if (logoToolTip) {
      logo = <Tooltip placement='right' overlay={logoToolTip}>
        {logo}
      </Tooltip>
    }
    return logo
  }

  return <section className='leftnav'>
    {renderLogo()}
    <div className='leftnav-links'>
      {renderMenus()}
    </div>
    {renderProfile()}
  </section>
}

export const LayoutMenu = compose(
  ReduxWrapper([
    sh.SessionToken,
    sh.SessionAccount
  ], [ah.clearUser]),
  QueryWrapper({
    key: 'LayoutMenu',
    actions: [
      {
        url: '/Services/Profile/Agency/Switch',
        prop: 'SwitchAgency',
        map: false
      }
    ]
  }),
  MessageBusWrapper
)(LayoutPrimaryMenuPlain)
